<template>
  <default-template-message class="mb30">
    <div class="default-email-message-template">
      <div class="default-email-message-template__section">
        <email-message-template-text-area
          class="default-email-message-template__title"
          field-name="greeting"
          :value="templateData.greeting"
          :max-length="fieldsMaxLength.greeting"
          @field-input="onTreatmentOfferFieldInput"
          @field-change="onTreatmentOfferFieldChange"
        />

        <email-message-template-text-areas
          :textarea-bindings="textareaBindings"
          @field-input="onTreatmentOfferFieldInput"
          @field-change="onTreatmentOfferFieldChange"
        />
      </div>

      <email-message-template-link-section :link-name="templateData.linkName" />
      <email-message-template-signature-section :template-data="templateData" />
    </div>
  </default-template-message>
</template>

<script>
import DefaultTemplateMessage from '@/modules/dashboard/components/message-templates/common/DefaultTemplateMessage';
import EmailMessageTemplateLinkSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateLinkSection';
import EmailMessageTemplateSignatureSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateSignatureSection';
import EmailMessageTemplateTextAreas from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateTextAreas';

import { getExistingFieldsTextareaBindings } from '@/modules/dashboard/utils';
import EmailMessageTemplateTextArea from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateTextArea';

export default {
  name: 'TreatmentOfferEmailTemplate',
  components: {
    EmailMessageTemplateTextArea,
    EmailMessageTemplateTextAreas,
    EmailMessageTemplateSignatureSection,
    EmailMessageTemplateLinkSection,
    DefaultTemplateMessage
  },
  props: {
    templateData: {
      type: Object,
      required: true
    },
    fieldsMaxLength: {
      type: Object,
      required: true
    }
  },
  computed: {
    textareaBindings() {
      return getExistingFieldsTextareaBindings({
        fields: ['bodyPartOne', 'bodyPartTwo', 'bodyPartThree', 'bodyPartFour'],
        templateData: this.templateData,
        fieldsMaxLength: this.fieldsMaxLength
      });
    }
  },
  methods: {
    onTreatmentOfferFieldInput(eventValue) {
      this.$emit('field-input', eventValue);
    },
    onTreatmentOfferFieldChange(eventValue) {
      this.$emit('field-change', eventValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/message-templates/email-message-templates';
</style>
